<div class="page-content-wrapper">
  <app-sidebar-layout [showMenuToggle]="true">
    <section class="card-style-sec mapping-grp-sec">
      <div class="container">
        <div class="row">
          <div class="col-md-12 card-main-title">
            <h4 class="card-title"> {{'Mapping Groups' | translate}}</h4>
          </div>
          <div class="col-md-12 top-nav-mapping-div">
            <ul class="nav nav-pills justify-content-between">
              @for (group of mappingGroupsList; track trackById($index, group)) {
                <li class="nav-item">
                  <a class="nav-link active" [class.active]="selectedGroup.id == group.id"
                  (click)="setGroup(group)">{{group.name}}</a>
                </li>
              }
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-3 col-lg-3">
            <div class="left-nav-mapping-div">
              @if (selectedGroup) {
                <h4 class="card-title">{{selectedGroup.name}}</h4>
              }
              <ul class="nav nav-pills mb-3 flex-wrap" id="pills-tab" role="tablist">
                @for (zone of zonesList; track trackById($index, zone)) {
                  <li class="nav-item zone-item" role="presentation" (mouseover)="highlightPolygon(zone, true)"
                    (mouseout)="highlightPolygon(zone, false)">
                    <mat-checkbox color="primary" class="ml-n2" [(ngModel)]="zone.isSelected" (click)="updateZones()"></mat-checkbox>
                    <div class="nav-link zone-title" role="tab" type="button" [class.active]="zone.isFocused" (click)="showInfoWindow(zone)">{{zone.name}}</div>
                    <div class="options-div">
                      <span class="options-btn material-icons bar-cd" (click)="showNamePopup(zone)" title="{{'Edit' | translate}}"> edit_note</span>
                      <span class="options-btn material-icons bar-cd" (click)="openZoneDeletePopup(zone)" title="{{'Delete' | translate}}">delete</span>
                    </div>
                  </li>
                }
              </ul>
            </div>
          </div>
          <div class="col-sm-12 col-md-9 col-lg-9">
            <div class="map-inner-main-div zones-google-map">
              <div class="video-wrap">
                <app-google-maps #googleMapRef [nodes]="nodes" [showZones]="true"
                  (latLongRes)="openLatLong($event)" (polygonHover)="polygonHover($event)" [loading]="loading"
                [zoneLatLng]="zoneLatLng"></app-google-maps>
                @if (isPolygonEditable) {
                  <div class="edit-button-outer">
                    <button class="main-btn save-btn" (click)="polygonSubmit()">
                    {{'Update Polygon' | translate}}</button>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </app-sidebar-layout>
</div>
